module.exports = __webpack_public_path__ + "static/media/logo-animado-2.a4375b15.gif";